import { UseFormSetValue } from "react-hook-form";
import {
  FormStep,
  SignUpFormData,
} from "../../SignUpFormTypes/signUpFormTypes";
import { getPhoneValue } from "./CustomInputs/PhoneInput/phoneHelpers";

export const getDataForSubmission = (formValues: SignUpFormData) => {
  const {
    agreement,
    email,
    firstName,
    lastName,
    otherProfession,
    password,
    phone,
    professionId,
    questions,
  } = formValues;

  questions.forEach(question => {
    if (typeof question !== "string" && question.value === "Select one")
      question.value = "";
  });

  return {
    email,
    firstName,
    globalProfessionId: professionId,
    lastName,
    otherProfession,
    password,
    phoneNumber: getPhoneValue(phone) ?? "",
    termsOfServiceAcceptance: agreement,
    questions,
  };
};

export const injectStylesInString = (
  str: string,
  htmlTag: string,
  style: string
) => {
  return str.replace(
    RegExp(`<${htmlTag}`, "gm"),
    `<${htmlTag} target="_blank" class="${style}"`
  );
};

export const getFieldQuestions = (steps: FormStep[]) => {
  const allFields = steps.map(step => step.fields);
  const allFieldsFlatted = allFields.flat(2);
  if (allFieldsFlatted.length === 0) return [];

  const questionsFields = allFieldsFlatted.filter(f => f.field === "questions");
  return questionsFields.map(questionsFields =>
    questionsFields.questionAttributes?.questionType === "multipleSelect"
      ? { value: [], name: questionsFields.questionAttributes?.questionName }
      : { value: "", name: questionsFields.questionAttributes?.questionName }
  );
};

export const isStringArray = (value: any): value is string[] => {
  return Array.isArray(value) && value.every(item => typeof item === "string");
};

let oldValue = "";
export const detectAutofill = (
  target: (EventTarget & HTMLInputElement) | HTMLElement | null,
  value?: string
) => {
  if (!target) return false;
  if (value === oldValue) return true;
  oldValue = value ?? "";
  const actualBg = window.getComputedStyle(target).backgroundColor;
  // These are the color of that the input bg can have
  if (actualBg !== "rgba(0, 0, 0, 0)" && actualBg !== "rgb(253, 239, 239)") {
    target.focus();
    target.blur();
    return true;
  }
  return false;
};

export const removeDataAttributesOfExtensions = (
  element: HTMLElement | null
) => {
  if (!element) return;

  element.removeAttribute("data-com-onepassword-filled");
};

export const removeValueFromPassword = (
  steps: FormStep[],
  currentStep: number,
  setValue: UseFormSetValue<SignUpFormData>,
  goingForward: boolean
) => {
  const index = goingForward ? +1 : -1;
  const options = goingForward
    ? {}
    : { shouldValidate: true, shouldTouch: true, shouldDirty: true };

  if (steps[currentStep + index].fields.some(f => f.field === "password"))
    setValue("password", "", options);
};
